import { LOGO } from "@/lib/brand";
import { MapPin, Mail, Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-brand-black border-t border-white/10 text-white/70" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid md:grid-cols-3 gap-10">
        <div>
          <div className="mb-4">
            <img src={LOGO} alt="Lansdowne RFC New York Youth Rugby Club" className="h-20 w-auto object-contain" />
          </div>
          <p className="text-sm max-w-xs">The fastest growing, affordable youth rugby program in Yonkers / Woodlawn. Ages 3–17. All experience levels welcome.</p>
        </div>
        <div>
          <h4 className="text-brand-gold font-display text-xl tracking-wide mb-4">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-2"><MapPin className="h-4 w-4 text-brand-red" /> Tibbetts Brook Park, Yonkers, NY</li>
            <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-brand-red" /> lansdownerfcyouth@gmail.com</li>
            <li className="flex items-center gap-2"><Instagram className="h-4 w-4 text-brand-red" /> @lansdownerfcny</li>
          </ul>
        </div>
        <div>
          <h4 className="text-brand-gold font-display text-xl tracking-wide mb-4">Explore</h4>
          <ul className="space-y-2 text-sm">
            <li><a href="/#programs" className="hover:text-brand-gold">Programs</a></li>
            <li><a href="/#events" className="hover:text-brand-gold">Events</a></li>
            <li><a href="/#gallery" className="hover:text-brand-gold">Gallery</a></li>
            <li><a href="/register" className="hover:text-brand-gold">Register</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-white/40 space-y-1">
        <div>© {new Date().getFullYear()} Lansdowne Youth Rugby · Founded 2022 by the Old Boys of Lansdowne RFC New York</div>
        <div>Powered by New Logical</div>
      </div>
    </footer>
  );
}
